// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/posts.scss
// module id = 292
// module chunks = 0